import React from "react";
import Home from "./components/Home";
// var dotenv = require('dotenv')
function App() {
    return(
        <Home />
    )
}

export default App;
